export default __webpack_public_path__ + "static/favicon-fe4a2d852bcdc93cb699dafc96b2906b.ico";